<template>
    <div>

        <p class='window white zksyncs' v-show="notice">
            USDP Pool has been updated, please contact @charlie_eth on Telegram for help in transfering liquidity and a
            gas refund.
        </p>
        <!-- <p class='simple-error window' v-show="config.blockchainId === 'polygon'" >
			 AAVE and REN pools gauges are migrating, please go to withdraw page and click the "Migrate to new gauge" button to keep receiving rewards.
			</p>
			<p class='simple-error window' v-show="config.blockchainId === 'fantom'" >
			 2pool, fusdt and REN pools gauges are migrating, please go to withdraw page and click the "Migrate to new gauge" button to keep receiving rewards.
			</p> -->


        <div v-if="!isGnosisSafeApp && config.blockchainId !== 'kava' && config.blockchainId !== 'celo'">
            <basic-trade />
        </div>

        <div class="window white poollist">
            <pool-list displayMax="10" />
        </div>

        <div v-show="config.blockchainId === 'ethereum'" class='window white'>
            <fieldset>
                <legend>veCRV stats</legend>
                <p>
                    <span>veCRV holder/LP ratio (based on fees): </span>
                    <span :class="{ 'loading line': ratio === null }"></span>
                    <span class='greentext' v-show='ratio !== null'>{{ ratio && ratio.toFixed(2) }}</span>
                <p class='info-message gentle-message'>
                    Having locked $1 in CRV for 4 years is equal to having provided ${{ ratio && ratio.toFixed(2) }} as
                    an LP
                </p>
                </p>
                veCRV holder APY: {{ feeAPY && feeAPY.toFixed(2) }}% (4 weeks average: {{ feeAPYAverage &&
                    feeAPYAverage.toFixed(2) }}%)

                <br>
                Yearly fee earnings per 1 veCRV:
                <span :class="{ 'loading line': feePerVeCRV === null }"></span>
                <span v-show='feePerVeCRV !== null'>${{ feePerVeCRVFormat }}</span>
                <br>
                My veCRV balance: {{ myVeCRVFormat }}
                <a v-show='myVeCRV == 0' href='https://dao.curve.finance/locker'>Stake CRV</a>
                <p v-show='myVeCRV > 0'>
                    My daily earnings:
                    <span :class="{ 'loading line': myFee === null }"></span>
                    ${{ myFee && myFee.toFixed(2) }} (${{ myFee && (myFee / 24).toFixed(2) }} per hour)
                    <br>
                    My yearly earnings: <span :class="{ 'loading line': myFee === null }"></span>
                    ${{ myFee && formatNumber(myFee * 365) }}
                    <span class='tooltip'>[?]
                        <span class='tooltiptext'>
                            Daily trading fee annualized
                        </span>
                    </span>
                    <br>
                </p>
                <p class='nomarginend'>
                    Averaged daily earnings:
                    <span :class="{ 'loading line': totalFees === null }"></span>
                    <span v-show='totalFees > 0'> ${{ totalFeesFormat }} </span>
                    <br>
                    Weekly earnings:
                    <span :class="{ 'loading line': totalWeeklyFeeFormat == 0 }"></span>
                    <span v-show='totalWeeklyFeeFormat'> ${{ totalWeeklyFeeFormat }}</span>
                    <br>
                    Weekly volume (including deposits/withdrawals):
                    <span :class="{ 'loading line': weeklyVolume == 0 }"></span>
                    <span v-show='weeklyVolume'> ${{ formatNumber(weeklyVolume) }}</span>
                </p>
                <p v-show="distroTime">
                    Next Distribution:
                    <span>{{ distroTime }}</span>
                </p>
            </fieldset>
        </div>

        <total-balances />

        <p v-show="config.blockchainId === 'ethereum'" class='window white zksyncs'>
            veCRV 3pool LP claim: <button @click='claim3LP'>Claim {{ LP3 && LP3.toFixed(2) }}</button>
        </p>
    </div>
</template>

<script>
import Vue from 'vue'
import TotalBalances from './TotalBalances.vue'
import BasicTrade from '../graphs/BasicTrade.vue'
import { contractAbis, ERC20_abi, CRV_address, balancer_ABI, balancer_address, liquiditygauge_abi, votingescrow_abi, votingescrow_address, fee_distro_abi, fee_distro_address } from '@/constants/abis'
import * as volumeStore from '@/components/common/volumeStore'
import * as priceStore from '@/components/common/priceStore'
import PoolList from '@/components/common/PoolList.vue'
import { arrayToHashmap } from '@/utils/helpers';
import BN from 'bignumber.js'

import * as helpers from '../../utils/helpers'
import getBalances from '../../utils/data/getBalances'
import config from '@/constants/config'
import { sendSafe } from '@/utils/Calls'
import getPricesForAssets from '@/utils/data/getPricesForAssets'
import pools, { poolIds } from '../../constants/pools'

import { contract } from '../../contract'

import { GraphQLClient, gql } from 'graphql-request'

import * as balancesStore from './balancesStore'
import * as gasPriceStore from '../common/gasPriceStore'

const initialBalancesValues = arrayToHashmap(pools.map(({ id }) => [id, -1]));

export default {
    components: {
        TotalBalances,
        BasicTrade,
        PoolList,
    },
    data: () => ({
        config,
        balances: initialBalancesValues,

        start: 0,
        end: 0,

        btcPrice: null,
        ethPrice: null,
        eurPrice: null,

        feeAPY: null,
        feeAPYAverage: null,
        feePerVeCRV: null,
        myVeCRV: null,
        myFee: null,
        totalFees: null,
        weeklyVolume: null,

        CRVprice: null,
        lockedCRV: null,
        ratio: null,
        notice: null,
        totalProfit: 0,
        weeklyFees: null,
        distroTime: null,
        LP3: 0,
    }),
    async created() {
        var start = new Date();
        start.setHours(0, 0, 0, 0);
        this.start = start.getTime() / 1000

        var end = new Date();
        end.setHours(23, 59, 59, 999);
        this.end = end.getTime() / 1000

        this.$watch(() => contract.web3 && contract.multicall, val => {
            if (!val) return;
            this.initialize();
        })
    },
    async mounted() {
        if (contract.web3 && contract.multicall) this.initialize();
        if (contract.default_account.toLowerCase() == '0xa6584b95ea4e9018b1f377dad99448ec478a150f' || contract.default_account.toLowerCase() == '	0xb92667e34cb6753449adf464f18ce1833caf26e0') {
            this.notice = true;
        }

    },
    watch: {
        totalBalances(val) {
            this.compareLPCRV()
        },
    },
    computed: {
        isGnosisSafeApp() {
            return window.parent !== window; // Just tests if displayed inside an iframe
        },
        totalVolume() {
            return volumeStore.totalVolume()
        },
        publicPath() {
            return process.env.BASE_URL
        },
        feePerVeCRVFormat() {
            return helpers.formatNumber(this.feePerVeCRV)
        },
        myVeCRVFormat() {
            return helpers.formatNumber(this.myVeCRV / 1e18)
        },
        totalFeesFormat() {
            return helpers.formatNumber(this.weeklyFees / 7)
        },

        totalWeeklyFeeFormat() {
            return helpers.formatNumber(this.weeklyFees)
        },
        totalBalances() {
            return balancesStore.state.total, this.lockedCRV, this.veCRVfees, Date.now()
        },
        feesSince() {
            return Math.round(Math.abs((Date.now() - 1600551527000) / (86400 * 1000)))
        },
    },
    methods: {
        async initialize() {

            if (config.blockchainId === 'ethereum') {
                this.get3LP();
                this.getVeCRVAPY();
            }

            const { balances } = await getBalances(contract.default_account);
            this.balances = { ...balances }; // Use new object instance for Vue to detect change
        },
        async get3LP() {
            this.LP3 = +(await contract.web3.eth.call({
                to: '0xA464e6DCda8AC41e03616F95f4BC98a13b8922Dc', data: contract.web3.eth.abi.encodeFunctionCall({
                    "name": "claim",
                    "outputs": [
                        {
                            "type": "uint256",
                            "name": ""
                        }
                    ],
                    "inputs": [
                        {
                            "type": "address",
                            "name": "_addr"
                        }
                    ],
                    "stateMutability": "nonpayable",
                    "type": "function"
                }, [contract.default_account])
            })) / 1e18
        },

        async getVeCRVAPY() {

            let calls = []
            this.votingEscrow = new contract.web3.eth.Contract(votingescrow_abi, votingescrow_address)
            calls.push(...[
                [this.votingEscrow._address, this.votingEscrow.methods.totalSupply().encodeABI()],
                [this.votingEscrow._address, this.votingEscrow.methods.balanceOf(contract.default_account || '0x0000000000000000000000000000000000000000').encodeABI()],
            ])
            let aggcalls = await contract.multicall.methods.aggregate(calls).call()
            let decoded = aggcalls[1].flatMap(hex => +contract.web3.eth.abi.decodeParameter('uint256', hex))
            let totalVeSupply = decoded[decoded.length - 2]
            this.myVeCRV = decoded[decoded.length - 1]

            let requests = await Promise.all([fetch('https://api.coingecko.com/api/v3/coins/curve-dao-token?tickers=false&market_data=true&community_data=false&developer_data=false&sparkline=false')])
            requests = await Promise.all(requests.map(request => request.json()))

            let veCRV = new contract.web3.eth.Contract(ERC20_abi, "0xD533a949740bb3306d119CC777fa900bA034cd52")
            let lockedCRV = await veCRV.methods.balanceOf(votingescrow_address).call();
            let CRVinfo = requests[0]
            let supply = CRVinfo.market_data.circulating_supply
            this.lockedCRV = lockedCRV

            const prices = await getPricesForAssets(['bitcoin', 'curve-dao-token']);
            let btcPrice = prices.bitcoin
            let CRVprice = prices['curve-dao-token']
            this.CRVprice = CRVprice

            /* weekly fees from contract*/
            let tri_pool = new contract.web3.eth.Contract(contractAbis['3pool'].swap_abi, contractAbis['3pool'].swap_address)
            let distributor = new contract.web3.eth.Contract(fee_distro_abi, fee_distro_address)
            let week = 604800;
            let t = await helpers.getThursdayUTCTimestamp();
            let thursday = t;
            let total = 0;
            let virtual_price = await tri_pool.methods.get_virtual_price().call()
            virtual_price = virtual_price / 1e18

            let weeklyFeesTable = []
            let fourweekAverage = 0;
            let weeksAvg = 1;
            for (var i = 0; i < 5; i++) {
                let thisWeekFees = await distributor.methods.tokens_per_week(t).call();
                if (thisWeekFees > 0) {
                    total += thisWeekFees * virtual_price / 1e18

                    let thisWeek = {
                        'date': new Date(t * 1000).toDateString(),
                        'fees': '$' + helpers.formatNumber(thisWeekFees * virtual_price / 1e18),
                        'rawFees': thisWeekFees * virtual_price / 1e18
                    }
                    if (i > 0 && weeksAvg < 5) {
                        fourweekAverage += thisWeekFees * virtual_price / 1e18
                        weeksAvg++
                    }
                    weeklyFeesTable.push(thisWeek)
                } else {
                    if (i > 8) {
                        i = 9 //end loop
                    }
                }
                t = t - week;
            }


            let currentTs = new Date().getTime() / 1000 | 0;
            if (currentTs > t) {
                let nextdistroTime = await distributor.methods.last_token_time().call();
                nextdistroTime = +nextdistroTime + 86400
                if (nextdistroTime > currentTs) {
                    let d = new Date(nextdistroTime * 1000);
                    this.distroTime = d.toUTCString();
                }
            }

            let weeklyFees = weeklyFeesTable[1].rawFees

            this.totalFees = weeklyFees / 7
            this.feeAPY = +this.totalFees * 365 / (+totalVeSupply / 1e18 * +CRVprice) * 100
            this.feeAPYAverage = (fourweekAverage / 4 / 7) * 365 / (+totalVeSupply / 1e18 * +CRVprice) * 100
            this.myFee = +this.totalFees * this.myVeCRV / totalVeSupply
            this.feePerVeCRV = +this.totalFees * 365 / (totalVeSupply / 1e18)

            this.weeklyFees = weeklyFees;
            this.weeklyVolume = weeklyFees * 100 / 0.02

            this.myFee = +weeklyFees / 7 * this.myVeCRV / totalVeSupply
            this.feePerVeCRV = weeklyFees * 52 / (totalVeSupply / 1e18)

            this.feeAPY = weeklyFees * 52 / (+totalVeSupply / 1e18 * +CRVprice) * 100

        },
        formatNumber(num) {
            return helpers.formatNumber(num)
        },
        compareLPCRV() {
            let TVL = balancesStore.state.total
            let LPfees = 50 / 100 * this.totalVolume / TVL
            let veCRVfees = 50 / 100 * this.totalVolume / ((this.lockedCRV / 1e18) * this.CRVprice)
            this.ratio = veCRVfees / LPfees
            if (!isFinite(this.ratio))
                this.ratio = null
        },

        async claim3LP() {

            let CRV = new contract.web3.eth.Contract(ERC20_abi, CRV_address)
            let allowance = BN(await CRV.methods.allowance(contract.default_account, votingescrow_address).call())
            let exceptions = ['0x33eecc48943aaeabb5328a25ff28eb85f67945c2']
            if (!exceptions.includes(contract.default_account.toLowerCase())) {
                if (!allowance.lte(contract.max_allowance.div(BN(2)))) {
                    await sendSafe(CRV.methods.approve(votingescrow_address, 0), {
                        from: contract.default_account,
                    });
                }
            }
            let feedistro = new contract.web3.eth.Contract(fee_distro_abi, fee_distro_address)
            await sendSafe(feedistro.methods.claim(), {
                from: contract.default_account,
            });
        },
    }
}
</script>

<style scoped>
@media only screen and (min-device-width : 320px) and (max-device-width : 730px) {
    #app .tradeview {
        width: 90%;
    }
}

.tooltip {
    position: relative;
    margin-left: 0;
}

.tooltiptext.long {
    max-width: 250px;
    position: absolute;
    margin-left: 0;
    transform: translateX(-50%) translateX(6px);
}

.tooltiptext.long a {
    display: inline-block;
    background: transparent;
    text-decoration: underline;
}

.tooltiptext.long>div {
    padding-left: 1em;
    text-align: left;
}

.tooltiptext.long>div:hover {
    background: none;
}

.nomarginend {
    margin-block-end: 0;
}

fieldset legend {
    text-align: center;
}

.greentext {
    color: darkgreen;
}

.zksyncs a {
    border-bottom: 1px dashed white;
}

.zksyncs a:hover {
    border-bottom: 1px solid white;
    text-decoration: none;
}

.zksyncs a,
.zksyncs a:hover,
.zksyncs a:visited {
    color: white;
}

.window.window.poollist {
    min-width: fit-content;
}

@media only screen and (max-device-width: 730px) {
    .window.window.poollist {
        padding-left: 0;
        padding-right: 0;
        border-left: 0;
        border-right: 0;
        margin-right: auto;
        margin-left: auto;
    }
}
</style>
